import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';

import { DisposalSitesServicesModule } from '@digital-platform/disposal-sites/services';
import { SharedUiModule } from '@digital-platform/shared/ui';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { UsersFeatureProfileDropdownModule } from '@digital-platform/users/feature-profile-dropdown';
import { UsersUiModule } from '@digital-platform/users/ui';
import { WasteProfilesUiModule } from '@digital-platform/waste-profiles/ui';
import { WasteServicesComponentsModule } from '@digital-platform/waste-services/components';
import { AccessCodeComponent } from './access-code/access-code.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { ContactDialogComponent } from './contact-dialog/contact-dialog.component';
import { ContactHoverBoxComponent } from './contact-hover-box/contact-hover-box.component';
import { DataMetricsComponent } from './data-metrics/data-metrics.component';
import { DivisionChipComponent } from './division-chip/division-chip.component';
import { EsriMapComponent } from './esri-map/esri-map.component';
import { TrackerDetailPopupComponent } from './esri-map/tracker-detail-popup/tracker-detail-popup.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LogoComponent } from './logo/logo.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ProfileSettingsComponent } from './profile-settings/profile-settings.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { StateRequiredDocumentsComponent } from './state-required-documents/state-required-documents.component';
import { ToDoProfilesComponent } from './to-do-profiles/to-do-profiles.component';
import { UpcomingServicesComponent } from './upcoming-services/upcoming-services.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedUiModule,
    SharedUiMaterialModule,
    UsersFeatureProfileDropdownModule,
    WasteProfilesUiModule,
    WasteServicesComponentsModule,
    UsersUiModule,
    MatDialogModule,
    DisposalSitesServicesModule,
    RouterModule.forChild([]),
  ],
  declarations: [
    HeaderComponent,
    SideNavComponent,
    LogoComponent,
    NotFoundComponent,
    ToDoProfilesComponent,
    UpcomingServicesComponent,
    ProfileSettingsComponent,
    AccessDeniedComponent,
    ContactDialogComponent,
    ServerErrorComponent,
    DataMetricsComponent,
    FooterComponent,
    ContactHoverBoxComponent,
    StateRequiredDocumentsComponent,
    EsriMapComponent,
    TrackerDetailPopupComponent,
    AccessCodeComponent,
    DivisionChipComponent,
  ],
  exports: [
    HeaderComponent,
    SideNavComponent,
    LogoComponent,
    ToDoProfilesComponent,
    UpcomingServicesComponent,
    ProfileSettingsComponent,
    AccessDeniedComponent,
    AccessCodeComponent,
    ServerErrorComponent,
    ContactDialogComponent,
    DataMetricsComponent,
    FooterComponent,
    StateRequiredDocumentsComponent,
    EsriMapComponent,
    TrackerDetailPopupComponent,
    DivisionChipComponent,
  ],
  providers: [DatePipe],
})
export class RiesHubUiComponentsModule {}
